import SEO from 'components/SEO';
import PublicLayout from 'layout/Public';
import React from 'react';
import DaktelaCustomerChat from 'sections/DaktelaCustomerChat';
import ErrorContent from 'sections/ErrorContent';

import { FormattedMessage, useIntl } from '@skippay/core/i18n/intl';

interface Props {
	statusCode: string;
}

function UnavailableScreen(props: Props): JSX.Element {
	const intl = useIntl();
	const { statusCode } = props;
	const reloadPage = () => window.location.reload();

	return (
		<PublicLayout>
			<SEO
				title={intl.formatMessage({
					id: 'screens.UnavailableScreen.title',
					defaultMessage: 'Stránka nedostupná',
				})}
			/>
			<DaktelaCustomerChat pageType="web" />

			<ErrorContent
				className="h-auto py-20"
				statusCode={statusCode}
				title={
					<FormattedMessage
						id="UnavailableScreen.label.title"
						defaultMessage="Ups, pardon, zrovna máme trable se serverem"
					/>
				}
				subheading={
					<FormattedMessage
						id="UnavailableScreen.label.message"
						defaultMessage="Web Skip Pay je teď bohužel dočasně nedostupný, ale náš tým už na tom pracuje. Zkuste to znovu později nebo obnovte stránku (někdy to pomůže). Děkujeme za trpělivost!"
					/>
				}
				onButtonClick={reloadPage}
				buttonLabel={
					<FormattedMessage id="UnavailableScreen.label.button" defaultMessage="Obnovit stránku" />
				}
			/>
		</PublicLayout>
	);
}

export default UnavailableScreen;
